/**
 * @generated SignedSource<<169256a5b03a005d070d65dc65792918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Step1SelectWorkflowGetGithubWorkflowInputsQuery$variables = {
  integrationId: any;
  repoFullName: string;
  workflowId: number;
};
export type Step1SelectWorkflowGetGithubWorkflowInputsQuery$data = {
  readonly getGithubWorkflowInputs: any;
};
export type Step1SelectWorkflowGetGithubWorkflowInputsQuery = {
  response: Step1SelectWorkflowGetGithubWorkflowInputsQuery$data;
  variables: Step1SelectWorkflowGetGithubWorkflowInputsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "repoFullName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workflowId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      },
      {
        "kind": "Variable",
        "name": "repoFullName",
        "variableName": "repoFullName"
      },
      {
        "kind": "Variable",
        "name": "workflowId",
        "variableName": "workflowId"
      }
    ],
    "kind": "ScalarField",
    "name": "getGithubWorkflowInputs",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Step1SelectWorkflowGetGithubWorkflowInputsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Step1SelectWorkflowGetGithubWorkflowInputsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfd79dcf97db5c98f74728845d6f5720",
    "id": null,
    "metadata": {},
    "name": "Step1SelectWorkflowGetGithubWorkflowInputsQuery",
    "operationKind": "query",
    "text": "query Step1SelectWorkflowGetGithubWorkflowInputsQuery(\n  $integrationId: GlobalID!\n  $repoFullName: String!\n  $workflowId: Int!\n) {\n  getGithubWorkflowInputs(integrationId: $integrationId, repoFullName: $repoFullName, workflowId: $workflowId)\n}\n"
  }
};
})();

(node as any).hash = "0bc68ffef219424f60f04b5d4060a9ea";

export default node;
